<script lang="ts">
	import { trackEvent } from '$lib/segment/client';
	import { shoppingCart } from '$lib/state/shoppingCart.svelte';
	import Overlay from '$lib/overlay.svelte';
	import CartContent from './cart/cartContent.svelte';

	function close() {
		trackEvent('Cart Modal Dismissed');
		shoppingCart.close();
	}
</script>

{#if shoppingCart.isOpen}
	<Overlay />
{/if}

<div
	class="fixed inset-0 z-[70] flex transform justify-end antialiased duration-[240ms] ease-linear"
	onclick={close}
	onkeydown={(e) => (e.key === 'Enter' || e.key === ' ' ? close() : null)}
	data-testid="shopping-cart"
	role="button"
	tabindex="0"
	class:translate-x-full={!shoppingCart.isOpen}
>
	<div class="relative h-dvh w-full lg:w-[480px] lg:p-5">
		<CartContent />
	</div>
</div>
